import economyJson from '../../economy.json'
import { economyFileSchema } from '../economy.schema'
import type { EconomyFile } from '../economy.schema'
import { ConfigError, formatIssues } from '../errors'

type DeepReadonly<T> = T extends readonly (infer U)[]
  ? readonly DeepReadonly<U>[]
  : T extends object
    ? { readonly [K in keyof T]: DeepReadonly<T[K]> }
    : T

/** Validated, frozen `economy.json` (D-038). */
export type Economy = DeepReadonly<EconomyFile>
export type Levels = Economy['levels']
export type DailyTask = Economy['daily']['tasks'][number]

/**
 * Validate `economy.json` on its own, without the balance/track loader, so the client menu can
 * use it. Throws `ConfigError` naming the failing path (`economy.daily.tasks.4.metric: …`).
 */
export function loadEconomy(raw: unknown = economyJson): Economy {
  const parsed = economyFileSchema.safeParse(raw)
  if (!parsed.success) {
    throw new ConfigError(`Invalid config\n${formatIssues('economy', parsed.error)}`)
  }
  return deepFreeze(parsed.data)
}

function deepFreeze<T>(value: T): DeepReadonly<T> {
  if (value !== null && typeof value === 'object') {
    for (const v of Object.values(value)) deepFreeze(v)
    Object.freeze(value)
  }
  return value as DeepReadonly<T>
}
